// FieldNoteFilterMenu.js
// This is the filter menu component for the Field Notes tab

import React, { useState } from "react";
// Components
import { SamplingEventDatePicker } from "../../../common/SamplingEventDatePicker";
// Styles
import styles from "../FieldNotesTab.module.css";

// Filter Menu Component
export const FieldNoteFilterMenu = ({
  filters,
  applyFilters,
  resetFilters,
  closeMenu,
  activeTab,
  employees = [],
  groups = [],
}) => {
  const [tempFilters, setTempFilters] = useState({ ...filters });

  const handleFilterChange = (field, value) => {
    setTempFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    applyFilters(tempFilters);
    closeMenu();
  };

  const handleReset = () => {
    const defaultFilters = {
      date: null,
      employeeId: "",
      groupId: "",
    };
    setTempFilters(defaultFilters);
    resetFilters();
    closeMenu();
  };

  return (
    <div className={styles.filterMenu}>
      {/* Date Filter (available on all tabs) */}
      <div className={styles.filterGroup}>
        <label htmlFor="dateFilter">Filter by Date:</label>
        <SamplingEventDatePicker
          id="dateFilter"
          selected={tempFilters.date}
          onChange={(date) => handleFilterChange("date", date)}
          dateFormat="MM/dd/yyyy"
          isClearable
          placeholderText="Select a date"
          className={styles.filterInput}
          showMonthDropdown
          showYearDropdown
          scrollableYearDropdown
        />
      </div>

      {/* Employee Filter (only for Group Notes and All Notes tabs) */}
      {(activeTab === "groupNotes" || activeTab === "allNotes") && (
        <div className={styles.filterGroup}>
          <label htmlFor="employeeFilter">Filter by Employee:</label>
          <select
            id="employeeFilter"
            className={styles.filterInput}
            value={tempFilters.employeeId}
            onChange={(e) => handleFilterChange("employeeId", e.target.value)}
          >
            <option value="">All Employees</option>
            {employees.map((employee) => (
              <option key={employee.id} value={employee.id}>
                {employee.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Group Filter (only for All Notes tab) */}
      {activeTab === "allNotes" && (
        <div className={styles.filterGroup}>
          <label htmlFor="groupFilter">Filter by Group:</label>
          <select
            id="groupFilter"
            className={styles.filterInput}
            value={tempFilters.groupId}
            onChange={(e) => handleFilterChange("groupId", e.target.value)}
          >
            <option value="">All Groups</option>
            {groups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.groupName || "Unnamed Group"}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className={styles.filterActions}>
        <button className={styles.resetFilter} onClick={handleReset}>
          Reset
        </button>
        <button className={styles.applyFilter} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};
